@if (environment.environmentCode.dto === EnvironmentCodeDTO.RABOBANK) {
  <div>
    <div class="container">
      <div class="row pt-5 pb-3">
        <div class="col-sm-8 offset-sm-2">
          <h2>Welkom bij Rabo Duurzaam Vastgoed</h2>
          Als een van de grootste vastgoedfinanciers van Nederland vinden wij het onze verantwoordelijkheid om een
          belangrijke bijdrage te leveren aan het verduurzamen van de Nederlandse vastgoedvoorraad. Duurzaam vastgoed
          staat bij ons voor toekomstbestendig vastgoed! <br /><br />
          Wij willen u helpen te verduurzamen op het niveau dat voor u realistisch en haalbaar is, maar wel past binnen de
          wetgeving en de doelstellingen die wij zelf als bank hebben. Hiervoor hebben we samen met onze partner CFP de
          tool Rabo Duurzaam Vastgoed ontwikkeld. Met deze tool krijgt u inzicht in uw potentiele
          energiebesparingsmogelijkheden, inclusief een indicatie van de investering en terugverdientijd. Let wel, dit
          eerste inzicht is slechts een richtlijn: om het besparingspotentieel en de benodigde investeringen te berekenen,
          wordt namelijk gebruik gemaakt van referentiegegevens. U kunt zelf uw besparingspotentieel ook verder
          specificeren door per pand de specifieke kenmerken verder in te vullen. Wij adviseren u een afspraak te maken
          met een door u zelf te kiezen adviseur om te bespreken welk verduurzamingsmaatregelen het best passend zijn voor
          uw vastgoedportefeuille. Uw eigen adviseur kan dan een gedetailleerd plan maken met het oog op verduurzaming
          .<br /><br />
          <em>Vragen</em><br />
          Voor vragen over het inloggen, technische problemen of de werking van de tool kunt u contact opnemen met
          support&#64;raboduurzaamvastgoed.nl. Uw vraag wordt beantwoord door onze partner CFP die deze tool ontwikkeld heeft.
          Voor inhoudelijke vragen over het commercieel vastgoed beleid van Rabobank kunt u contact opnemen met uw
          accountmanager.
        </div>
      </div>
    </div>
  </div>
}
